export var firebaseConfig = {
apiKey: "AIzaSyCtYn3fjF-z6OOmxncXl8g3fr95u1chCTo",
authDomain: "react-admin-firebase-1.firebaseapp.com",
databaseURL: "https://react-admin-firebase-1.firebaseio.com",
projectId: "react-admin-firebase-1",
storageBucket: "react-admin-firebase-1.appspot.com",
messagingSenderId: "14660317743",
appId: "1:14660317743:web:e4b09f3cdabbfcec",
debug: true
};


// WEBPACK FOOTER //
// ./src/FIREBASE_CONFIG.js